import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1l0 -3","key":"svg-0"}],["path",{"d":"M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4","key":"svg-1"}],["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-2"}],["path",{"d":"M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3","key":"svg-3"}]]

const IconFileLike = createReactComponent('outline', 'file-like', 'FileLike', __iconNode);

export default IconFileLike;